import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsThree', {
    title: 'Verification',
    notAllPersonsFilled: 'Please fill in form for all personas selected for verification',
});
